<template>
	<!-- info card start -->
    <div class="card">
        <div class="card-header">
            <h5 class="card-header-text">Final Notes</h5>
            <button class="btn btn-sm btn-primary waves-effect waves-light f-right" data-target="#addComment" data-toggle="modal">
                Add Comment
            </button>
        </div>
        <div class="card-block">
        	<div class="row">
                <div class="col-md-12">
                    <div class="card b-l-success business-info services m-b-10" v-for="(note, index) in final_notes">
                        <div class="card-block">
                            <div class="row">
                                <div class="col-sm-12">
	                            	<ul class="media-list">
	                            		<li class="media">
										    <div class="media-body">
										        <h6 class="media-heading">{{note.evaluator.first_name + " " + note.evaluator.last_name}}<span class="f-12 text-muted m-l-5">{{note.created_at.split(" ")[0]}}</span></h6>
										        <p class="m-b-0">{{note.note}}</p>
										        <hr>
										    </div>
										</li>
	                            	</ul>
	                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="addComment" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Add Comment</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="addFinalNote">
                            <div class="form-group">
                                <label>Comment:</label>
                                <textarea class="form-control" style="height: 250px;" v-model="add_comment.note" placeholder="Your comments here..."></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-success">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css" soped>
	tr td:nth-child(1){
		font-weight: bold;
	}
</style>
<script type="text/javascript">
	export default{
		name: 'CBTScores',
		data(){
			return{
				add_comment: {
					applicant_id: this.$route.params.id,
					evaluator_id: this.$store.getters.user_data.data.id,
					note: ""
				},

				final_notes: []
			}
		},
		methods: {
			init: function(){
				this.getFinalNote(this.$route.params.id)
			},

			addFinalNote: function(){
				console.log(this.add_comment)

				var comment = {
					what: 'CreateFinalNote',
					data: this.add_comment
				}

				this.$socket.makePostRequest(comment)
                    .then((response)=>{
                        if(response.type == "CreateFinalNote"){
                            this.$swal.fire("Success", "Comment Added", 'success')

                            setTimeout(()=>{
                            	this.getFinalNote(this.$route.params.id)

                            	$('.modal').modal('hide')

                            	this.add_comment.note = ""
                            }, 2000)
                        }
                    })
                    .catch((error)=>{
                        console.log(error)
                    })
			},

			getFinalNote: function(applicant_id){

	            var note = {
	                what: 'GetFinalNote',
	                id: applicant_id
	            }

	            this.$socket.makeGetRequest(note)
	                .then((response)=>{
	                    if(response.type == 'GetFinalNote'){
	                        this.final_notes = response.data
	                    }
	                        
	                })
	                .catch((e)=>{
	                    console.log(e)
	                })
	        },
		},
		mounted(){
			this.init()
		}
	}
</script>